module.exports = "<div class=\"homeBg\">\r\n  <app-new-main-header></app-new-main-header>\r\n\r\n  <app-footer></app-footer>\r\n</div>"